/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';
import { WorkGenerateFromTemplateV3Dto } from '../models/work-generate-from-template-v-3-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsGeneratorV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsGeneratorV3ControllerGenerateFromTemplate()` */
  static readonly DocumentsGeneratorV3ControllerGenerateFromTemplatePath = '/v3/documents-generator';

  /**
   * Required permissions: documents:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV3ControllerGenerateFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV3ControllerGenerateFromTemplate$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV3Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorV3Service.DocumentsGeneratorV3ControllerGenerateFromTemplatePath, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'blob', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Required permissions: documents:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV3ControllerGenerateFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV3ControllerGenerateFromTemplate(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV3Dto
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.documentsGeneratorV3ControllerGenerateFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4()` */
  static readonly DocumentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4Path = '/v3/documents-generator/v4';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorV3Service.DocumentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4Path, 'post');
    if (params) {
      rb.query('format', params.format, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4(
    params: {
      format: WorkDocxOutputFormatEnum;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.documentsGeneratorV3ControllerGenerateFromTemplateForOfficeV4$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
